import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"

class Marquee extends Component {
  render() {
    const content = this.props.content
    const sectionClasses = helpers.sectionClasses(content.sectionOptions)
    return (
      <section className={`${sectionClasses}`}>
        <div className="hero-marquee">
          <div className="marquee">
            <div className="clipped-text small marquee-text">
              {content.text} {content.text}
            </div>
            <div className="clipped-text small marquee-text">
              {content.text} {content.text}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Marquee
